import { CustomerEmployeeService } from "./CustomerEmployeeService";

export type { ICustomerEmployeeService } from "./ICustomerEmployeeService";

export const customerEmployeeService = new CustomerEmployeeService();
